// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: execution.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import {
  Denomination,
  denominationFromJSON,
  denominationToJSON,
  Order,
  OrderSide,
  orderSideFromJSON,
  orderSideToJSON,
  OrderType,
  orderTypeFromJSON,
  orderTypeToJSON,
  TimeInForce,
  timeInForceFromJSON,
  timeInForceToJSON,
} from './common/trading'
import {
  AcceptRfqQuoteParams,
  CancelRfqMakerQuoteParams,
  CancelRfqParams,
  CreateRfqParams,
  SendRfqMakerQuoteParams,
} from './rfq'

export const protobufPackage = 'execution'

export enum LimitPriceAnchor {
  LIMIT_PRICE_ANCHOR_UNSPECIFIED = 0,
  LIMIT_PRICE_ANCHOR_BEST_BID = 1,
  LIMIT_PRICE_ANCHOR_BEST_ASK = 2,
  LIMIT_PRICE_ANCHOR_MID_PRICE = 3,
  UNRECOGNIZED = -1,
}

export function limitPriceAnchorFromJSON(object: any): LimitPriceAnchor {
  switch (object) {
    case 0:
    case 'LIMIT_PRICE_ANCHOR_UNSPECIFIED':
      return LimitPriceAnchor.LIMIT_PRICE_ANCHOR_UNSPECIFIED
    case 1:
    case 'LIMIT_PRICE_ANCHOR_BEST_BID':
      return LimitPriceAnchor.LIMIT_PRICE_ANCHOR_BEST_BID
    case 2:
    case 'LIMIT_PRICE_ANCHOR_BEST_ASK':
      return LimitPriceAnchor.LIMIT_PRICE_ANCHOR_BEST_ASK
    case 3:
    case 'LIMIT_PRICE_ANCHOR_MID_PRICE':
      return LimitPriceAnchor.LIMIT_PRICE_ANCHOR_MID_PRICE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LimitPriceAnchor.UNRECOGNIZED
  }
}

export function limitPriceAnchorToJSON(object: LimitPriceAnchor): string {
  switch (object) {
    case LimitPriceAnchor.LIMIT_PRICE_ANCHOR_UNSPECIFIED:
      return 'LIMIT_PRICE_ANCHOR_UNSPECIFIED'
    case LimitPriceAnchor.LIMIT_PRICE_ANCHOR_BEST_BID:
      return 'LIMIT_PRICE_ANCHOR_BEST_BID'
    case LimitPriceAnchor.LIMIT_PRICE_ANCHOR_BEST_ASK:
      return 'LIMIT_PRICE_ANCHOR_BEST_ASK'
    case LimitPriceAnchor.LIMIT_PRICE_ANCHOR_MID_PRICE:
      return 'LIMIT_PRICE_ANCHOR_MID_PRICE'
    case LimitPriceAnchor.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum LimitPriceOffsetUnit {
  LIMIT_PRICE_OFFSET_UNIT_UNSPECIFIED = 0,
  /** LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE - Offset is in quote-price units. */
  LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE = 1,
  /** LIMIT_PRICE_OFFSET_UNIT_BPS - Offset is signed basis points. */
  LIMIT_PRICE_OFFSET_UNIT_BPS = 2,
  /** LIMIT_PRICE_OFFSET_UNIT_PERCENT - Offset is signed percent. */
  LIMIT_PRICE_OFFSET_UNIT_PERCENT = 3,
  /** LIMIT_PRICE_OFFSET_UNIT_TICKS - Offset is signed exchange ticks. */
  LIMIT_PRICE_OFFSET_UNIT_TICKS = 4,
  UNRECOGNIZED = -1,
}

export function limitPriceOffsetUnitFromJSON(object: any): LimitPriceOffsetUnit {
  switch (object) {
    case 0:
    case 'LIMIT_PRICE_OFFSET_UNIT_UNSPECIFIED':
      return LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_UNSPECIFIED
    case 1:
    case 'LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE':
      return LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE
    case 2:
    case 'LIMIT_PRICE_OFFSET_UNIT_BPS':
      return LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_BPS
    case 3:
    case 'LIMIT_PRICE_OFFSET_UNIT_PERCENT':
      return LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_PERCENT
    case 4:
    case 'LIMIT_PRICE_OFFSET_UNIT_TICKS':
      return LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_TICKS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LimitPriceOffsetUnit.UNRECOGNIZED
  }
}

export function limitPriceOffsetUnitToJSON(object: LimitPriceOffsetUnit): string {
  switch (object) {
    case LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_UNSPECIFIED:
      return 'LIMIT_PRICE_OFFSET_UNIT_UNSPECIFIED'
    case LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE:
      return 'LIMIT_PRICE_OFFSET_UNIT_QUOTE_VALUE'
    case LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_BPS:
      return 'LIMIT_PRICE_OFFSET_UNIT_BPS'
    case LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_PERCENT:
      return 'LIMIT_PRICE_OFFSET_UNIT_PERCENT'
    case LimitPriceOffsetUnit.LIMIT_PRICE_OFFSET_UNIT_TICKS:
      return 'LIMIT_PRICE_OFFSET_UNIT_TICKS'
    case LimitPriceOffsetUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface OrderExecutionCommandList {
  commands: OrderExecutionCommand[]
}

/** Order execution command - unified command structure */
export interface OrderExecutionCommand {
  accountId: string
  new?: NewOrderParams | undefined
  update?: UpdateOrderParams | undefined
  cancel?: CancelOrderParams | undefined
  /** Only set this if you don't want to cancel Algos, otherwise this is primarely internally use */
  cancelAll?: CancelAllOrdersParams | undefined
  createRfq?: CreateRfqParams | undefined
  cancelRfq?: CancelRfqParams | undefined
  acceptRfqQuote?: AcceptRfqQuoteParams | undefined
  /**
   * RFQ maker (spec Decision 8): published by public-api straight to the
   * venue subject, no algo. Paradigm-network quotes go to execution.PARADIGM.*.
   */
  sendRfqMakerQuote?: SendRfqMakerQuoteParams | undefined
  cancelRfqMakerQuote?: CancelRfqMakerQuoteParams | undefined
  /**
   * ENG-1063 D13/D17: arm or re-arm the generation-scoped dead-man for
   * `label`, reserving `open_orders_reserved` of the account's open-order cap.
   * `ttl_ms = 0` disarms and releases the reservation.
   */
  armDeadman?: ArmDeadman | undefined
  /**
   * ENG-1063 D19: change size and/or price of a resting order in place
   * where the venue supports it (Deribit `private/edit`, Bybit
   * `/v5/order/amend`). A venue without in-place amend rejects it.
   */
  amendOrder?: AmendOrderParams | undefined
  /**
   * ENG-1063 D21: initial and maintenance margin of a candidate fill set,
   * computed by the venue. Answered by `MarginSimulated` on
   * `notifications.{account_id}`.
   */
  simulateMargin?: SimulateMarginParams | undefined
  /**
   * ENG-1063: the sender's dead-man generation. A venue holding a dead-man
   * entry for the command's label refuses a mismatch; absent bypasses.
   */
  sessionGeneration?: string | undefined
}

/**
 * ENG-1063 D14: market-maker protection, applied by the venue where it
 * exposes MMP. Decimal strings like every other quantity on the wire.
 */
export interface MmpConfig {
  intervalMs: number
  frozenMs: number
  qtyLimit: string
  deltaLimit: string
  /**
   * The chain's base currency (BTC, ETH, ...). Each venue maps it to its MMP
   * scope: Deribit index_name, Bybit baseCoin, Derive currency.
   */
  underlying: string
}

export interface ArmDeadman {
  label: string
  generation: string
  ttlMs: number
  openOrdersReserved: number
  mmp?: MmpConfig | undefined
  /**
   * The instance's chain base (BTC, ETH, ...). A venue whose open-order cap
   * is per coin (Bybit options) reserves the slots under that coin; empty
   * means account-wide, which is what a sender predating this field sends.
   */
  underlying: string
}

export interface AmendOrderParams {
  accountId: string
  orderId: string
  /** New total size, decimal string (not a delta). */
  newSize: string
  newPrice?: string | undefined
  /** The order's owner label (the dead-man gate checks it). */
  label: string
  symbol: string
  correlationId?: string | undefined
}

/** ENG-1063 D21: one leg of a candidate fill set. Decimal strings. */
export interface MarginLegParams {
  symbol: string
  side: OrderSide
  quantity: string
  price: string
}

export interface SimulateMarginParams {
  correlationId: string
  legs: MarginLegParams[]
}

/**
 * Carries the cancellation scope through to fire time so a triggered
 * cancel-all (e.g. "cancel my BTC limits if BTC < 60k") doesn't need to
 * re-resolve scope on fire. `symbol` absent = cancel all open orders for
 * the account; present = limit to that symbol.
 */
export interface CancelAllOrdersParams {
  accountId: string
  symbol?: string | undefined
  /**
   * Opaque frontend-owned correlation id, echoed back on any resulting
   * notification (e.g. OrderExecutionError) so the UI can map it to the
   * originating action. Server assigns no semantics to it.
   */
  correlationId?: string | undefined
}

export interface TriggerCondition {
  /** Decimal as string */
  priceAbove?: string | undefined
  /** Decimal as string */
  priceBelow?: string | undefined
}

export interface RelativeLimitPrice {
  anchor: LimitPriceAnchor
  /** Signed Decimal as string. Defaults to 0. */
  offset?: string | undefined
  offsetUnit: LimitPriceOffsetUnit
}

/**
 * New order parameters.
 *
 * Routing identity (trade_venue, exchange, venue_symbol) is server-derived:
 * the trade_venue comes from the account record (DDB), and the venue binary
 * resolves the venue-native symbol from `symbol` via MetaClient.
 */
export interface NewOrderParams {
  accountId: string
  orderSide: OrderSide
  /** normalized market symbol */
  symbol: string
  quantity: string
  orderType: OrderType
  displayAmount?: string | undefined
  price?: string | undefined
  denomination: Denomination
  label?: string | undefined
  /** stop loss / take profit orders */
  triggerCondition?: TriggerCondition | undefined
  /** for derivatives exchanges */
  reduceOnly?: boolean | undefined
  /** for limit orders */
  postOnly?: boolean | undefined
  /** e.g., GTC, IOC, FOK */
  tif?: TimeInForce | undefined
  /** present iff this leg came from an order preset */
  presetId?: string | undefined
  /** Alternative to absolute `price` for limit orders. */
  relativePrice?: RelativeLimitPrice | undefined
  /**
   * Opaque frontend-owned correlation id, echoed back on any resulting
   * notification so the UI can map it to the originating action. Optional;
   * server assigns no semantics to it.
   */
  correlationId?: string | undefined
}

/**
 * Update order parameters.
 *
 * Routing identity (trade_venue, exchange, venue_symbol) is server-derived,
 * same as NewOrderParams.
 */
export interface UpdateOrderParams {
  accountId: string
  orderId: string
  quantity?: string | undefined
  price?: string | undefined
  displayAmount?: string | undefined
  label: string
  symbol: string
  /** stop loss / take profit orders */
  triggerCondition?: TriggerCondition | undefined
  /** for derivatives exchanges */
  reduceOnly?: boolean | undefined
  /** for limit orders */
  postOnly?: boolean | undefined
  /**
   * Opaque frontend-owned correlation id, echoed back on any resulting
   * notification so the UI can map it to the originating action. Optional.
   */
  correlationId?: string | undefined
}

/** Cancel order parameters. */
export interface CancelOrderParams {
  accountId: string
  orderId: string
  label: string
  symbol: string
  /**
   * Opaque frontend-owned correlation id, echoed back on any resulting
   * notification so the UI can map it to the originating action. Optional.
   */
  correlationId?: string | undefined
  /** stop/conditional order; venue cancels via its conditional bucket (Bybit spot StopOrder) */
  isConditional?: boolean | undefined
}

export interface LiveOrdersRequest {
  /**
   * When set, only orders whose label starts with this prefix are returned.
   * Algos pass their algo id; children are labelled `{algo_id}...`.
   */
  labelPrefix: string
}

export interface LiveOrdersSnapshot {
  /**
   * Every open order on the exchange for the account, filtered by
   * `label_prefix`. Order.label is the OEMS label the order was placed with,
   * or empty when the venue cannot map it back (orders placed outside OEMS).
   */
  orders: Order[]
  /**
   * Wall-clock ms taken before the exchange was queried. An order whose
   * placement reached the venue after this instant may be missing. Always
   * non-zero, so an empty list never encodes to the zero-length refusal.
   */
  asOfMs: string
}

function createBaseOrderExecutionCommandList(): OrderExecutionCommandList {
  return { commands: [] }
}

export const OrderExecutionCommandList: MessageFns<OrderExecutionCommandList> = {
  encode(
    message: OrderExecutionCommandList,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    for (const v of message.commands) {
      OrderExecutionCommand.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderExecutionCommandList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderExecutionCommandList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.commands.push(OrderExecutionCommand.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderExecutionCommandList {
    return {
      commands: globalThis.Array.isArray(object?.commands)
        ? object.commands.map((e: any) => OrderExecutionCommand.fromJSON(e))
        : [],
    }
  },

  toJSON(message: OrderExecutionCommandList): unknown {
    const obj: any = {}
    if (message.commands?.length) {
      obj.commands = message.commands.map((e) => OrderExecutionCommand.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderExecutionCommandList>, I>>(
    base?: I
  ): OrderExecutionCommandList {
    return OrderExecutionCommandList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderExecutionCommandList>, I>>(
    object: I
  ): OrderExecutionCommandList {
    const message = createBaseOrderExecutionCommandList()
    message.commands = object.commands?.map((e) => OrderExecutionCommand.fromPartial(e)) || []
    return message
  },
}

function createBaseOrderExecutionCommand(): OrderExecutionCommand {
  return {
    accountId: '',
    new: undefined,
    update: undefined,
    cancel: undefined,
    cancelAll: undefined,
    createRfq: undefined,
    cancelRfq: undefined,
    acceptRfqQuote: undefined,
    sendRfqMakerQuote: undefined,
    cancelRfqMakerQuote: undefined,
    armDeadman: undefined,
    amendOrder: undefined,
    simulateMargin: undefined,
    sessionGeneration: undefined,
  }
}

export const OrderExecutionCommand: MessageFns<OrderExecutionCommand> = {
  encode(message: OrderExecutionCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.new !== undefined) {
      NewOrderParams.encode(message.new, writer.uint32(18).fork()).join()
    }
    if (message.update !== undefined) {
      UpdateOrderParams.encode(message.update, writer.uint32(26).fork()).join()
    }
    if (message.cancel !== undefined) {
      CancelOrderParams.encode(message.cancel, writer.uint32(34).fork()).join()
    }
    if (message.cancelAll !== undefined) {
      CancelAllOrdersParams.encode(message.cancelAll, writer.uint32(42).fork()).join()
    }
    if (message.createRfq !== undefined) {
      CreateRfqParams.encode(message.createRfq, writer.uint32(50).fork()).join()
    }
    if (message.cancelRfq !== undefined) {
      CancelRfqParams.encode(message.cancelRfq, writer.uint32(58).fork()).join()
    }
    if (message.acceptRfqQuote !== undefined) {
      AcceptRfqQuoteParams.encode(message.acceptRfqQuote, writer.uint32(66).fork()).join()
    }
    if (message.sendRfqMakerQuote !== undefined) {
      SendRfqMakerQuoteParams.encode(message.sendRfqMakerQuote, writer.uint32(74).fork()).join()
    }
    if (message.cancelRfqMakerQuote !== undefined) {
      CancelRfqMakerQuoteParams.encode(message.cancelRfqMakerQuote, writer.uint32(82).fork()).join()
    }
    if (message.armDeadman !== undefined) {
      ArmDeadman.encode(message.armDeadman, writer.uint32(114).fork()).join()
    }
    if (message.amendOrder !== undefined) {
      AmendOrderParams.encode(message.amendOrder, writer.uint32(98).fork()).join()
    }
    if (message.simulateMargin !== undefined) {
      SimulateMarginParams.encode(message.simulateMargin, writer.uint32(106).fork()).join()
    }
    if (message.sessionGeneration !== undefined) {
      writer.uint32(88).uint64(message.sessionGeneration)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderExecutionCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderExecutionCommand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.new = NewOrderParams.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.update = UpdateOrderParams.decode(reader, reader.uint32())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.cancel = CancelOrderParams.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.cancelAll = CancelAllOrdersParams.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.createRfq = CreateRfqParams.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.cancelRfq = CancelRfqParams.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.acceptRfqQuote = AcceptRfqQuoteParams.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.sendRfqMakerQuote = SendRfqMakerQuoteParams.decode(reader, reader.uint32())
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.cancelRfqMakerQuote = CancelRfqMakerQuoteParams.decode(reader, reader.uint32())
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.armDeadman = ArmDeadman.decode(reader, reader.uint32())
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.amendOrder = AmendOrderParams.decode(reader, reader.uint32())
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.simulateMargin = SimulateMarginParams.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.sessionGeneration = reader.uint64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderExecutionCommand {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      new: isSet(object.new) ? NewOrderParams.fromJSON(object.new) : undefined,
      update: isSet(object.update) ? UpdateOrderParams.fromJSON(object.update) : undefined,
      cancel: isSet(object.cancel) ? CancelOrderParams.fromJSON(object.cancel) : undefined,
      cancelAll: isSet(object.cancelAll)
        ? CancelAllOrdersParams.fromJSON(object.cancelAll)
        : isSet(object.cancel_all)
          ? CancelAllOrdersParams.fromJSON(object.cancel_all)
          : undefined,
      createRfq: isSet(object.createRfq)
        ? CreateRfqParams.fromJSON(object.createRfq)
        : isSet(object.create_rfq)
          ? CreateRfqParams.fromJSON(object.create_rfq)
          : undefined,
      cancelRfq: isSet(object.cancelRfq)
        ? CancelRfqParams.fromJSON(object.cancelRfq)
        : isSet(object.cancel_rfq)
          ? CancelRfqParams.fromJSON(object.cancel_rfq)
          : undefined,
      acceptRfqQuote: isSet(object.acceptRfqQuote)
        ? AcceptRfqQuoteParams.fromJSON(object.acceptRfqQuote)
        : isSet(object.accept_rfq_quote)
          ? AcceptRfqQuoteParams.fromJSON(object.accept_rfq_quote)
          : undefined,
      sendRfqMakerQuote: isSet(object.sendRfqMakerQuote)
        ? SendRfqMakerQuoteParams.fromJSON(object.sendRfqMakerQuote)
        : isSet(object.send_rfq_maker_quote)
          ? SendRfqMakerQuoteParams.fromJSON(object.send_rfq_maker_quote)
          : undefined,
      cancelRfqMakerQuote: isSet(object.cancelRfqMakerQuote)
        ? CancelRfqMakerQuoteParams.fromJSON(object.cancelRfqMakerQuote)
        : isSet(object.cancel_rfq_maker_quote)
          ? CancelRfqMakerQuoteParams.fromJSON(object.cancel_rfq_maker_quote)
          : undefined,
      armDeadman: isSet(object.armDeadman)
        ? ArmDeadman.fromJSON(object.armDeadman)
        : isSet(object.arm_deadman)
          ? ArmDeadman.fromJSON(object.arm_deadman)
          : undefined,
      amendOrder: isSet(object.amendOrder)
        ? AmendOrderParams.fromJSON(object.amendOrder)
        : isSet(object.amend_order)
          ? AmendOrderParams.fromJSON(object.amend_order)
          : undefined,
      simulateMargin: isSet(object.simulateMargin)
        ? SimulateMarginParams.fromJSON(object.simulateMargin)
        : isSet(object.simulate_margin)
          ? SimulateMarginParams.fromJSON(object.simulate_margin)
          : undefined,
      sessionGeneration: isSet(object.sessionGeneration)
        ? globalThis.String(object.sessionGeneration)
        : isSet(object.session_generation)
          ? globalThis.String(object.session_generation)
          : undefined,
    }
  },

  toJSON(message: OrderExecutionCommand): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.new !== undefined) {
      obj.new = NewOrderParams.toJSON(message.new)
    }
    if (message.update !== undefined) {
      obj.update = UpdateOrderParams.toJSON(message.update)
    }
    if (message.cancel !== undefined) {
      obj.cancel = CancelOrderParams.toJSON(message.cancel)
    }
    if (message.cancelAll !== undefined) {
      obj.cancelAll = CancelAllOrdersParams.toJSON(message.cancelAll)
    }
    if (message.createRfq !== undefined) {
      obj.createRfq = CreateRfqParams.toJSON(message.createRfq)
    }
    if (message.cancelRfq !== undefined) {
      obj.cancelRfq = CancelRfqParams.toJSON(message.cancelRfq)
    }
    if (message.acceptRfqQuote !== undefined) {
      obj.acceptRfqQuote = AcceptRfqQuoteParams.toJSON(message.acceptRfqQuote)
    }
    if (message.sendRfqMakerQuote !== undefined) {
      obj.sendRfqMakerQuote = SendRfqMakerQuoteParams.toJSON(message.sendRfqMakerQuote)
    }
    if (message.cancelRfqMakerQuote !== undefined) {
      obj.cancelRfqMakerQuote = CancelRfqMakerQuoteParams.toJSON(message.cancelRfqMakerQuote)
    }
    if (message.armDeadman !== undefined) {
      obj.armDeadman = ArmDeadman.toJSON(message.armDeadman)
    }
    if (message.amendOrder !== undefined) {
      obj.amendOrder = AmendOrderParams.toJSON(message.amendOrder)
    }
    if (message.simulateMargin !== undefined) {
      obj.simulateMargin = SimulateMarginParams.toJSON(message.simulateMargin)
    }
    if (message.sessionGeneration !== undefined) {
      obj.sessionGeneration = message.sessionGeneration
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderExecutionCommand>, I>>(base?: I): OrderExecutionCommand {
    return OrderExecutionCommand.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderExecutionCommand>, I>>(
    object: I
  ): OrderExecutionCommand {
    const message = createBaseOrderExecutionCommand()
    message.accountId = object.accountId ?? ''
    message.new =
      object.new !== undefined && object.new !== null
        ? NewOrderParams.fromPartial(object.new)
        : undefined
    message.update =
      object.update !== undefined && object.update !== null
        ? UpdateOrderParams.fromPartial(object.update)
        : undefined
    message.cancel =
      object.cancel !== undefined && object.cancel !== null
        ? CancelOrderParams.fromPartial(object.cancel)
        : undefined
    message.cancelAll =
      object.cancelAll !== undefined && object.cancelAll !== null
        ? CancelAllOrdersParams.fromPartial(object.cancelAll)
        : undefined
    message.createRfq =
      object.createRfq !== undefined && object.createRfq !== null
        ? CreateRfqParams.fromPartial(object.createRfq)
        : undefined
    message.cancelRfq =
      object.cancelRfq !== undefined && object.cancelRfq !== null
        ? CancelRfqParams.fromPartial(object.cancelRfq)
        : undefined
    message.acceptRfqQuote =
      object.acceptRfqQuote !== undefined && object.acceptRfqQuote !== null
        ? AcceptRfqQuoteParams.fromPartial(object.acceptRfqQuote)
        : undefined
    message.sendRfqMakerQuote =
      object.sendRfqMakerQuote !== undefined && object.sendRfqMakerQuote !== null
        ? SendRfqMakerQuoteParams.fromPartial(object.sendRfqMakerQuote)
        : undefined
    message.cancelRfqMakerQuote =
      object.cancelRfqMakerQuote !== undefined && object.cancelRfqMakerQuote !== null
        ? CancelRfqMakerQuoteParams.fromPartial(object.cancelRfqMakerQuote)
        : undefined
    message.armDeadman =
      object.armDeadman !== undefined && object.armDeadman !== null
        ? ArmDeadman.fromPartial(object.armDeadman)
        : undefined
    message.amendOrder =
      object.amendOrder !== undefined && object.amendOrder !== null
        ? AmendOrderParams.fromPartial(object.amendOrder)
        : undefined
    message.simulateMargin =
      object.simulateMargin !== undefined && object.simulateMargin !== null
        ? SimulateMarginParams.fromPartial(object.simulateMargin)
        : undefined
    message.sessionGeneration = object.sessionGeneration ?? undefined
    return message
  },
}

function createBaseMmpConfig(): MmpConfig {
  return { intervalMs: 0, frozenMs: 0, qtyLimit: '', deltaLimit: '', underlying: '' }
}

export const MmpConfig: MessageFns<MmpConfig> = {
  encode(message: MmpConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervalMs !== 0) {
      writer.uint32(8).uint32(message.intervalMs)
    }
    if (message.frozenMs !== 0) {
      writer.uint32(16).uint32(message.frozenMs)
    }
    if (message.qtyLimit !== '') {
      writer.uint32(26).string(message.qtyLimit)
    }
    if (message.deltaLimit !== '') {
      writer.uint32(34).string(message.deltaLimit)
    }
    if (message.underlying !== '') {
      writer.uint32(42).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MmpConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMmpConfig()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.intervalMs = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.frozenMs = reader.uint32()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.qtyLimit = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.deltaLimit = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MmpConfig {
    return {
      intervalMs: isSet(object.intervalMs)
        ? globalThis.Number(object.intervalMs)
        : isSet(object.interval_ms)
          ? globalThis.Number(object.interval_ms)
          : 0,
      frozenMs: isSet(object.frozenMs)
        ? globalThis.Number(object.frozenMs)
        : isSet(object.frozen_ms)
          ? globalThis.Number(object.frozen_ms)
          : 0,
      qtyLimit: isSet(object.qtyLimit)
        ? globalThis.String(object.qtyLimit)
        : isSet(object.qty_limit)
          ? globalThis.String(object.qty_limit)
          : '',
      deltaLimit: isSet(object.deltaLimit)
        ? globalThis.String(object.deltaLimit)
        : isSet(object.delta_limit)
          ? globalThis.String(object.delta_limit)
          : '',
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: MmpConfig): unknown {
    const obj: any = {}
    if (message.intervalMs !== 0) {
      obj.intervalMs = Math.round(message.intervalMs)
    }
    if (message.frozenMs !== 0) {
      obj.frozenMs = Math.round(message.frozenMs)
    }
    if (message.qtyLimit !== '') {
      obj.qtyLimit = message.qtyLimit
    }
    if (message.deltaLimit !== '') {
      obj.deltaLimit = message.deltaLimit
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MmpConfig>, I>>(base?: I): MmpConfig {
    return MmpConfig.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MmpConfig>, I>>(object: I): MmpConfig {
    const message = createBaseMmpConfig()
    message.intervalMs = object.intervalMs ?? 0
    message.frozenMs = object.frozenMs ?? 0
    message.qtyLimit = object.qtyLimit ?? ''
    message.deltaLimit = object.deltaLimit ?? ''
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseArmDeadman(): ArmDeadman {
  return {
    label: '',
    generation: '0',
    ttlMs: 0,
    openOrdersReserved: 0,
    mmp: undefined,
    underlying: '',
  }
}

export const ArmDeadman: MessageFns<ArmDeadman> = {
  encode(message: ArmDeadman, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.generation !== '0') {
      writer.uint32(16).uint64(message.generation)
    }
    if (message.ttlMs !== 0) {
      writer.uint32(24).uint32(message.ttlMs)
    }
    if (message.openOrdersReserved !== 0) {
      writer.uint32(32).uint32(message.openOrdersReserved)
    }
    if (message.mmp !== undefined) {
      MmpConfig.encode(message.mmp, writer.uint32(42).fork()).join()
    }
    if (message.underlying !== '') {
      writer.uint32(50).string(message.underlying)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArmDeadman {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseArmDeadman()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.generation = reader.uint64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.ttlMs = reader.uint32()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.openOrdersReserved = reader.uint32()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.mmp = MmpConfig.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.underlying = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ArmDeadman {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      generation: isSet(object.generation) ? globalThis.String(object.generation) : '0',
      ttlMs: isSet(object.ttlMs)
        ? globalThis.Number(object.ttlMs)
        : isSet(object.ttl_ms)
          ? globalThis.Number(object.ttl_ms)
          : 0,
      openOrdersReserved: isSet(object.openOrdersReserved)
        ? globalThis.Number(object.openOrdersReserved)
        : isSet(object.open_orders_reserved)
          ? globalThis.Number(object.open_orders_reserved)
          : 0,
      mmp: isSet(object.mmp) ? MmpConfig.fromJSON(object.mmp) : undefined,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
    }
  },

  toJSON(message: ArmDeadman): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.generation !== '0') {
      obj.generation = message.generation
    }
    if (message.ttlMs !== 0) {
      obj.ttlMs = Math.round(message.ttlMs)
    }
    if (message.openOrdersReserved !== 0) {
      obj.openOrdersReserved = Math.round(message.openOrdersReserved)
    }
    if (message.mmp !== undefined) {
      obj.mmp = MmpConfig.toJSON(message.mmp)
    }
    if (message.underlying !== '') {
      obj.underlying = message.underlying
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ArmDeadman>, I>>(base?: I): ArmDeadman {
    return ArmDeadman.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ArmDeadman>, I>>(object: I): ArmDeadman {
    const message = createBaseArmDeadman()
    message.label = object.label ?? ''
    message.generation = object.generation ?? '0'
    message.ttlMs = object.ttlMs ?? 0
    message.openOrdersReserved = object.openOrdersReserved ?? 0
    message.mmp =
      object.mmp !== undefined && object.mmp !== null
        ? MmpConfig.fromPartial(object.mmp)
        : undefined
    message.underlying = object.underlying ?? ''
    return message
  },
}

function createBaseAmendOrderParams(): AmendOrderParams {
  return {
    accountId: '',
    orderId: '',
    newSize: '',
    newPrice: undefined,
    label: '',
    symbol: '',
    correlationId: undefined,
  }
}

export const AmendOrderParams: MessageFns<AmendOrderParams> = {
  encode(message: AmendOrderParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    if (message.newSize !== '') {
      writer.uint32(26).string(message.newSize)
    }
    if (message.newPrice !== undefined) {
      writer.uint32(34).string(message.newPrice)
    }
    if (message.label !== '') {
      writer.uint32(42).string(message.label)
    }
    if (message.symbol !== '') {
      writer.uint32(50).string(message.symbol)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(58).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AmendOrderParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAmendOrderParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.newSize = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.newPrice = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AmendOrderParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      newSize: isSet(object.newSize)
        ? globalThis.String(object.newSize)
        : isSet(object.new_size)
          ? globalThis.String(object.new_size)
          : '',
      newPrice: isSet(object.newPrice)
        ? globalThis.String(object.newPrice)
        : isSet(object.new_price)
          ? globalThis.String(object.new_price)
          : undefined,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: AmendOrderParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.newSize !== '') {
      obj.newSize = message.newSize
    }
    if (message.newPrice !== undefined) {
      obj.newPrice = message.newPrice
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AmendOrderParams>, I>>(base?: I): AmendOrderParams {
    return AmendOrderParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AmendOrderParams>, I>>(object: I): AmendOrderParams {
    const message = createBaseAmendOrderParams()
    message.accountId = object.accountId ?? ''
    message.orderId = object.orderId ?? ''
    message.newSize = object.newSize ?? ''
    message.newPrice = object.newPrice ?? undefined
    message.label = object.label ?? ''
    message.symbol = object.symbol ?? ''
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseMarginLegParams(): MarginLegParams {
  return { symbol: '', side: 0, quantity: '', price: '' }
}

export const MarginLegParams: MessageFns<MarginLegParams> = {
  encode(message: MarginLegParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.side !== 0) {
      writer.uint32(16).int32(message.side)
    }
    if (message.quantity !== '') {
      writer.uint32(26).string(message.quantity)
    }
    if (message.price !== '') {
      writer.uint32(34).string(message.price)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarginLegParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMarginLegParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MarginLegParams {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      price: isSet(object.price) ? globalThis.String(object.price) : '',
    }
  },

  toJSON(message: MarginLegParams): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MarginLegParams>, I>>(base?: I): MarginLegParams {
    return MarginLegParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MarginLegParams>, I>>(object: I): MarginLegParams {
    const message = createBaseMarginLegParams()
    message.symbol = object.symbol ?? ''
    message.side = object.side ?? 0
    message.quantity = object.quantity ?? ''
    message.price = object.price ?? ''
    return message
  },
}

function createBaseSimulateMarginParams(): SimulateMarginParams {
  return { correlationId: '', legs: [] }
}

export const SimulateMarginParams: MessageFns<SimulateMarginParams> = {
  encode(message: SimulateMarginParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.correlationId !== '') {
      writer.uint32(10).string(message.correlationId)
    }
    for (const v of message.legs) {
      MarginLegParams.encode(v!, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimulateMarginParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSimulateMarginParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.legs.push(MarginLegParams.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SimulateMarginParams {
    return {
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : '',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => MarginLegParams.fromJSON(e))
        : [],
    }
  },

  toJSON(message: SimulateMarginParams): unknown {
    const obj: any = {}
    if (message.correlationId !== '') {
      obj.correlationId = message.correlationId
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => MarginLegParams.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SimulateMarginParams>, I>>(base?: I): SimulateMarginParams {
    return SimulateMarginParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SimulateMarginParams>, I>>(
    object: I
  ): SimulateMarginParams {
    const message = createBaseSimulateMarginParams()
    message.correlationId = object.correlationId ?? ''
    message.legs = object.legs?.map((e) => MarginLegParams.fromPartial(e)) || []
    return message
  },
}

function createBaseCancelAllOrdersParams(): CancelAllOrdersParams {
  return { accountId: '', symbol: undefined, correlationId: undefined }
}

export const CancelAllOrdersParams: MessageFns<CancelAllOrdersParams> = {
  encode(message: CancelAllOrdersParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.symbol !== undefined) {
      writer.uint32(18).string(message.symbol)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(26).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelAllOrdersParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelAllOrdersParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelAllOrdersParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: CancelAllOrdersParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.symbol !== undefined) {
      obj.symbol = message.symbol
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelAllOrdersParams>, I>>(base?: I): CancelAllOrdersParams {
    return CancelAllOrdersParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelAllOrdersParams>, I>>(
    object: I
  ): CancelAllOrdersParams {
    const message = createBaseCancelAllOrdersParams()
    message.accountId = object.accountId ?? ''
    message.symbol = object.symbol ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseTriggerCondition(): TriggerCondition {
  return { priceAbove: undefined, priceBelow: undefined }
}

export const TriggerCondition: MessageFns<TriggerCondition> = {
  encode(message: TriggerCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.priceAbove !== undefined) {
      writer.uint32(10).string(message.priceAbove)
    }
    if (message.priceBelow !== undefined) {
      writer.uint32(18).string(message.priceBelow)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTriggerCondition()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.priceAbove = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.priceBelow = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TriggerCondition {
    return {
      priceAbove: isSet(object.priceAbove)
        ? globalThis.String(object.priceAbove)
        : isSet(object.price_above)
          ? globalThis.String(object.price_above)
          : undefined,
      priceBelow: isSet(object.priceBelow)
        ? globalThis.String(object.priceBelow)
        : isSet(object.price_below)
          ? globalThis.String(object.price_below)
          : undefined,
    }
  },

  toJSON(message: TriggerCondition): unknown {
    const obj: any = {}
    if (message.priceAbove !== undefined) {
      obj.priceAbove = message.priceAbove
    }
    if (message.priceBelow !== undefined) {
      obj.priceBelow = message.priceBelow
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TriggerCondition>, I>>(base?: I): TriggerCondition {
    return TriggerCondition.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TriggerCondition>, I>>(object: I): TriggerCondition {
    const message = createBaseTriggerCondition()
    message.priceAbove = object.priceAbove ?? undefined
    message.priceBelow = object.priceBelow ?? undefined
    return message
  },
}

function createBaseRelativeLimitPrice(): RelativeLimitPrice {
  return { anchor: 0, offset: undefined, offsetUnit: 0 }
}

export const RelativeLimitPrice: MessageFns<RelativeLimitPrice> = {
  encode(message: RelativeLimitPrice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.anchor !== 0) {
      writer.uint32(8).int32(message.anchor)
    }
    if (message.offset !== undefined) {
      writer.uint32(18).string(message.offset)
    }
    if (message.offsetUnit !== 0) {
      writer.uint32(24).int32(message.offsetUnit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RelativeLimitPrice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRelativeLimitPrice()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.anchor = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.offset = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.offsetUnit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RelativeLimitPrice {
    return {
      anchor: isSet(object.anchor) ? limitPriceAnchorFromJSON(object.anchor) : 0,
      offset: isSet(object.offset) ? globalThis.String(object.offset) : undefined,
      offsetUnit: isSet(object.offsetUnit)
        ? limitPriceOffsetUnitFromJSON(object.offsetUnit)
        : isSet(object.offset_unit)
          ? limitPriceOffsetUnitFromJSON(object.offset_unit)
          : 0,
    }
  },

  toJSON(message: RelativeLimitPrice): unknown {
    const obj: any = {}
    if (message.anchor !== 0) {
      obj.anchor = limitPriceAnchorToJSON(message.anchor)
    }
    if (message.offset !== undefined) {
      obj.offset = message.offset
    }
    if (message.offsetUnit !== 0) {
      obj.offsetUnit = limitPriceOffsetUnitToJSON(message.offsetUnit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RelativeLimitPrice>, I>>(base?: I): RelativeLimitPrice {
    return RelativeLimitPrice.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RelativeLimitPrice>, I>>(object: I): RelativeLimitPrice {
    const message = createBaseRelativeLimitPrice()
    message.anchor = object.anchor ?? 0
    message.offset = object.offset ?? undefined
    message.offsetUnit = object.offsetUnit ?? 0
    return message
  },
}

function createBaseNewOrderParams(): NewOrderParams {
  return {
    accountId: '',
    orderSide: 0,
    symbol: '',
    quantity: '',
    orderType: 0,
    displayAmount: undefined,
    price: undefined,
    denomination: 0,
    label: undefined,
    triggerCondition: undefined,
    reduceOnly: undefined,
    postOnly: undefined,
    tif: undefined,
    presetId: undefined,
    relativePrice: undefined,
    correlationId: undefined,
  }
}

export const NewOrderParams: MessageFns<NewOrderParams> = {
  encode(message: NewOrderParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.orderSide !== 0) {
      writer.uint32(16).int32(message.orderSide)
    }
    if (message.symbol !== '') {
      writer.uint32(26).string(message.symbol)
    }
    if (message.quantity !== '') {
      writer.uint32(34).string(message.quantity)
    }
    if (message.orderType !== 0) {
      writer.uint32(40).int32(message.orderType)
    }
    if (message.displayAmount !== undefined) {
      writer.uint32(50).string(message.displayAmount)
    }
    if (message.price !== undefined) {
      writer.uint32(58).string(message.price)
    }
    if (message.denomination !== 0) {
      writer.uint32(64).int32(message.denomination)
    }
    if (message.label !== undefined) {
      writer.uint32(74).string(message.label)
    }
    if (message.triggerCondition !== undefined) {
      TriggerCondition.encode(message.triggerCondition, writer.uint32(82).fork()).join()
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(88).bool(message.reduceOnly)
    }
    if (message.postOnly !== undefined) {
      writer.uint32(96).bool(message.postOnly)
    }
    if (message.tif !== undefined) {
      writer.uint32(104).int32(message.tif)
    }
    if (message.presetId !== undefined) {
      writer.uint32(114).string(message.presetId)
    }
    if (message.relativePrice !== undefined) {
      RelativeLimitPrice.encode(message.relativePrice, writer.uint32(122).fork()).join()
    }
    if (message.correlationId !== undefined) {
      writer.uint32(130).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NewOrderParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseNewOrderParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.orderSide = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.orderType = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.displayAmount = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.denomination = reader.int32() as any
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.triggerCondition = TriggerCondition.decode(reader, reader.uint32())
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 12: {
          if (tag !== 96) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
        case 13: {
          if (tag !== 104) {
            break
          }

          message.tif = reader.int32() as any
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.relativePrice = RelativeLimitPrice.decode(reader, reader.uint32())
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): NewOrderParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      orderSide: isSet(object.orderSide)
        ? orderSideFromJSON(object.orderSide)
        : isSet(object.order_side)
          ? orderSideFromJSON(object.order_side)
          : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
      orderType: isSet(object.orderType)
        ? orderTypeFromJSON(object.orderType)
        : isSet(object.order_type)
          ? orderTypeFromJSON(object.order_type)
          : 0,
      displayAmount: isSet(object.displayAmount)
        ? globalThis.String(object.displayAmount)
        : isSet(object.display_amount)
          ? globalThis.String(object.display_amount)
          : undefined,
      price: isSet(object.price) ? globalThis.String(object.price) : undefined,
      denomination: isSet(object.denomination) ? denominationFromJSON(object.denomination) : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
      triggerCondition: isSet(object.triggerCondition)
        ? TriggerCondition.fromJSON(object.triggerCondition)
        : isSet(object.trigger_condition)
          ? TriggerCondition.fromJSON(object.trigger_condition)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : undefined,
      tif: isSet(object.tif) ? timeInForceFromJSON(object.tif) : undefined,
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : undefined,
      relativePrice: isSet(object.relativePrice)
        ? RelativeLimitPrice.fromJSON(object.relativePrice)
        : isSet(object.relative_price)
          ? RelativeLimitPrice.fromJSON(object.relative_price)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: NewOrderParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.orderSide !== 0) {
      obj.orderSide = orderSideToJSON(message.orderSide)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    if (message.orderType !== 0) {
      obj.orderType = orderTypeToJSON(message.orderType)
    }
    if (message.displayAmount !== undefined) {
      obj.displayAmount = message.displayAmount
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.denomination !== 0) {
      obj.denomination = denominationToJSON(message.denomination)
    }
    if (message.label !== undefined) {
      obj.label = message.label
    }
    if (message.triggerCondition !== undefined) {
      obj.triggerCondition = TriggerCondition.toJSON(message.triggerCondition)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.postOnly !== undefined) {
      obj.postOnly = message.postOnly
    }
    if (message.tif !== undefined) {
      obj.tif = timeInForceToJSON(message.tif)
    }
    if (message.presetId !== undefined) {
      obj.presetId = message.presetId
    }
    if (message.relativePrice !== undefined) {
      obj.relativePrice = RelativeLimitPrice.toJSON(message.relativePrice)
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<NewOrderParams>, I>>(base?: I): NewOrderParams {
    return NewOrderParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<NewOrderParams>, I>>(object: I): NewOrderParams {
    const message = createBaseNewOrderParams()
    message.accountId = object.accountId ?? ''
    message.orderSide = object.orderSide ?? 0
    message.symbol = object.symbol ?? ''
    message.quantity = object.quantity ?? ''
    message.orderType = object.orderType ?? 0
    message.displayAmount = object.displayAmount ?? undefined
    message.price = object.price ?? undefined
    message.denomination = object.denomination ?? 0
    message.label = object.label ?? undefined
    message.triggerCondition =
      object.triggerCondition !== undefined && object.triggerCondition !== null
        ? TriggerCondition.fromPartial(object.triggerCondition)
        : undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    message.postOnly = object.postOnly ?? undefined
    message.tif = object.tif ?? undefined
    message.presetId = object.presetId ?? undefined
    message.relativePrice =
      object.relativePrice !== undefined && object.relativePrice !== null
        ? RelativeLimitPrice.fromPartial(object.relativePrice)
        : undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseUpdateOrderParams(): UpdateOrderParams {
  return {
    accountId: '',
    orderId: '',
    quantity: undefined,
    price: undefined,
    displayAmount: undefined,
    label: '',
    symbol: '',
    triggerCondition: undefined,
    reduceOnly: undefined,
    postOnly: undefined,
    correlationId: undefined,
  }
}

export const UpdateOrderParams: MessageFns<UpdateOrderParams> = {
  encode(message: UpdateOrderParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    if (message.quantity !== undefined) {
      writer.uint32(26).string(message.quantity)
    }
    if (message.price !== undefined) {
      writer.uint32(34).string(message.price)
    }
    if (message.displayAmount !== undefined) {
      writer.uint32(42).string(message.displayAmount)
    }
    if (message.label !== '') {
      writer.uint32(50).string(message.label)
    }
    if (message.symbol !== '') {
      writer.uint32(58).string(message.symbol)
    }
    if (message.triggerCondition !== undefined) {
      TriggerCondition.encode(message.triggerCondition, writer.uint32(66).fork()).join()
    }
    if (message.reduceOnly !== undefined) {
      writer.uint32(72).bool(message.reduceOnly)
    }
    if (message.postOnly !== undefined) {
      writer.uint32(80).bool(message.postOnly)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(90).string(message.correlationId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrderParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdateOrderParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quantity = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.displayAmount = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.triggerCondition = TriggerCondition.decode(reader, reader.uint32())
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.reduceOnly = reader.bool()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.postOnly = reader.bool()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdateOrderParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : undefined,
      price: isSet(object.price) ? globalThis.String(object.price) : undefined,
      displayAmount: isSet(object.displayAmount)
        ? globalThis.String(object.displayAmount)
        : isSet(object.display_amount)
          ? globalThis.String(object.display_amount)
          : undefined,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      triggerCondition: isSet(object.triggerCondition)
        ? TriggerCondition.fromJSON(object.triggerCondition)
        : isSet(object.trigger_condition)
          ? TriggerCondition.fromJSON(object.trigger_condition)
          : undefined,
      reduceOnly: isSet(object.reduceOnly)
        ? globalThis.Boolean(object.reduceOnly)
        : isSet(object.reduce_only)
          ? globalThis.Boolean(object.reduce_only)
          : undefined,
      postOnly: isSet(object.postOnly)
        ? globalThis.Boolean(object.postOnly)
        : isSet(object.post_only)
          ? globalThis.Boolean(object.post_only)
          : undefined,
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
    }
  },

  toJSON(message: UpdateOrderParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.quantity !== undefined) {
      obj.quantity = message.quantity
    }
    if (message.price !== undefined) {
      obj.price = message.price
    }
    if (message.displayAmount !== undefined) {
      obj.displayAmount = message.displayAmount
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.triggerCondition !== undefined) {
      obj.triggerCondition = TriggerCondition.toJSON(message.triggerCondition)
    }
    if (message.reduceOnly !== undefined) {
      obj.reduceOnly = message.reduceOnly
    }
    if (message.postOnly !== undefined) {
      obj.postOnly = message.postOnly
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdateOrderParams>, I>>(base?: I): UpdateOrderParams {
    return UpdateOrderParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrderParams>, I>>(object: I): UpdateOrderParams {
    const message = createBaseUpdateOrderParams()
    message.accountId = object.accountId ?? ''
    message.orderId = object.orderId ?? ''
    message.quantity = object.quantity ?? undefined
    message.price = object.price ?? undefined
    message.displayAmount = object.displayAmount ?? undefined
    message.label = object.label ?? ''
    message.symbol = object.symbol ?? ''
    message.triggerCondition =
      object.triggerCondition !== undefined && object.triggerCondition !== null
        ? TriggerCondition.fromPartial(object.triggerCondition)
        : undefined
    message.reduceOnly = object.reduceOnly ?? undefined
    message.postOnly = object.postOnly ?? undefined
    message.correlationId = object.correlationId ?? undefined
    return message
  },
}

function createBaseCancelOrderParams(): CancelOrderParams {
  return {
    accountId: '',
    orderId: '',
    label: '',
    symbol: '',
    correlationId: undefined,
    isConditional: undefined,
  }
}

export const CancelOrderParams: MessageFns<CancelOrderParams> = {
  encode(message: CancelOrderParams, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accountId !== '') {
      writer.uint32(10).string(message.accountId)
    }
    if (message.orderId !== '') {
      writer.uint32(18).string(message.orderId)
    }
    if (message.label !== '') {
      writer.uint32(26).string(message.label)
    }
    if (message.symbol !== '') {
      writer.uint32(34).string(message.symbol)
    }
    if (message.correlationId !== undefined) {
      writer.uint32(42).string(message.correlationId)
    }
    if (message.isConditional !== undefined) {
      writer.uint32(48).bool(message.isConditional)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelOrderParams {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelOrderParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.orderId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.label = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.correlationId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.isConditional = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelOrderParams {
    return {
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      orderId: isSet(object.orderId)
        ? globalThis.String(object.orderId)
        : isSet(object.order_id)
          ? globalThis.String(object.order_id)
          : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      correlationId: isSet(object.correlationId)
        ? globalThis.String(object.correlationId)
        : isSet(object.correlation_id)
          ? globalThis.String(object.correlation_id)
          : undefined,
      isConditional: isSet(object.isConditional)
        ? globalThis.Boolean(object.isConditional)
        : isSet(object.is_conditional)
          ? globalThis.Boolean(object.is_conditional)
          : undefined,
    }
  },

  toJSON(message: CancelOrderParams): unknown {
    const obj: any = {}
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.orderId !== '') {
      obj.orderId = message.orderId
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId
    }
    if (message.isConditional !== undefined) {
      obj.isConditional = message.isConditional
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelOrderParams>, I>>(base?: I): CancelOrderParams {
    return CancelOrderParams.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelOrderParams>, I>>(object: I): CancelOrderParams {
    const message = createBaseCancelOrderParams()
    message.accountId = object.accountId ?? ''
    message.orderId = object.orderId ?? ''
    message.label = object.label ?? ''
    message.symbol = object.symbol ?? ''
    message.correlationId = object.correlationId ?? undefined
    message.isConditional = object.isConditional ?? undefined
    return message
  },
}

function createBaseLiveOrdersRequest(): LiveOrdersRequest {
  return { labelPrefix: '' }
}

export const LiveOrdersRequest: MessageFns<LiveOrdersRequest> = {
  encode(message: LiveOrdersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.labelPrefix !== '') {
      writer.uint32(10).string(message.labelPrefix)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveOrdersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLiveOrdersRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.labelPrefix = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LiveOrdersRequest {
    return {
      labelPrefix: isSet(object.labelPrefix)
        ? globalThis.String(object.labelPrefix)
        : isSet(object.label_prefix)
          ? globalThis.String(object.label_prefix)
          : '',
    }
  },

  toJSON(message: LiveOrdersRequest): unknown {
    const obj: any = {}
    if (message.labelPrefix !== '') {
      obj.labelPrefix = message.labelPrefix
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LiveOrdersRequest>, I>>(base?: I): LiveOrdersRequest {
    return LiveOrdersRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LiveOrdersRequest>, I>>(object: I): LiveOrdersRequest {
    const message = createBaseLiveOrdersRequest()
    message.labelPrefix = object.labelPrefix ?? ''
    return message
  },
}

function createBaseLiveOrdersSnapshot(): LiveOrdersSnapshot {
  return { orders: [], asOfMs: '0' }
}

export const LiveOrdersSnapshot: MessageFns<LiveOrdersSnapshot> = {
  encode(message: LiveOrdersSnapshot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orders) {
      Order.encode(v!, writer.uint32(10).fork()).join()
    }
    if (message.asOfMs !== '0') {
      writer.uint32(16).int64(message.asOfMs)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveOrdersSnapshot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLiveOrdersSnapshot()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orders.push(Order.decode(reader, reader.uint32()))
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.asOfMs = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LiveOrdersSnapshot {
    return {
      orders: globalThis.Array.isArray(object?.orders)
        ? object.orders.map((e: any) => Order.fromJSON(e))
        : [],
      asOfMs: isSet(object.asOfMs)
        ? globalThis.String(object.asOfMs)
        : isSet(object.as_of_ms)
          ? globalThis.String(object.as_of_ms)
          : '0',
    }
  },

  toJSON(message: LiveOrdersSnapshot): unknown {
    const obj: any = {}
    if (message.orders?.length) {
      obj.orders = message.orders.map((e) => Order.toJSON(e))
    }
    if (message.asOfMs !== '0') {
      obj.asOfMs = message.asOfMs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LiveOrdersSnapshot>, I>>(base?: I): LiveOrdersSnapshot {
    return LiveOrdersSnapshot.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LiveOrdersSnapshot>, I>>(object: I): LiveOrdersSnapshot {
    const message = createBaseLiveOrdersSnapshot()
    message.orders = object.orders?.map((e) => Order.fromPartial(e)) || []
    message.asOfMs = object.asOfMs ?? '0'
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
